import { render, staticRenderFns } from "./ProductDn.vue?vue&type=template&id=7177444c"
import script from "./ProductDn.vue?vue&type=script&lang=js"
export * from "./ProductDn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports